import partner from './partner/actions';
import user from './user/actions';
import roster from './roster/actions';
import runtime from './app-runtime/actions';
import student from './student/actions';
import learningContinuum from './learning-continuum/actions';

export default {
    partner,
    user,
    roster,
    runtime,
    student,
    learningContinuum,
};
